import React from 'react'
import Box from '@mui/material/Box'
import Link from '@mui/material/Link'

export const socialLinks = [
  {
    name: 'YouTube',
    link: 'https://www.youtube.com/fxnoob',
    icon: '/images/icons/youtube.svg',
  },
  {
    name: 'Github',
    link: 'https://github.com/fxnoob',
    icon: '/images/icons/github.svg',
  },
]

const SocialLinkItem = ({ item }) => (
  <Box
    component="li"
    sx={{
      display: 'inline-block',
      mr: 0.5,
    }}
  >
    <Link
      target="_blank"
      sx={{
        lineHeight: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 36,
        height: 36,
        borderRadius: '50%',
        color: 'black',
        '&:hover': {
          backgroundColor: 'secondary.main',
        },
        '& img': {
          fill: 'currentColor',
          width: 22,
          height: 'auto',
        },
      }}
      href={item.link}
    >
      <img src={item.icon} alt={item.name + 'icon'} />
    </Link>
  </Box>
)

// default
const SocialLinks = () => {
  return (
    <Box sx={{ ml: -1 }}>
      <Box
        component="ul"
        sx={{
          m: 0,
          p: 0,
          lineHeight: 0,
          borderRadius: 3,
          listStyle: 'none',
        }}
      >
        {socialLinks.map((item) => {
          return <SocialLinkItem key={item.name} item={item} />
        })}
      </Box>
    </Box>
  )
}

export default SocialLinks
